<template>
  <div id="app">
    <router-view />
    <popup-loading v-if="loading"></popup-loading>
  </div>
</template>

<script>
import { PopupLoading } from "./components/popup"
import { mapState } from "vuex"
export default {
  components: {
    PopupLoading
  },
  computed: {
    ...mapState(["loading"])
  }
}
</script>

<style lang="less">
body {
  background: #f9f9f9;
  padding: 0;
  margin: 0;
  height: 100vh;
  color: #333333;
}
#app {
  font-size: 30px;
}
.btn {
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border: 0;
  background-color: transparent;
  background-image: linear-gradient(180deg, #ffbb40 4%, #ff7840 100%);
  box-shadow: 0 4px 11px 0 rgba(255, 120, 64, 0.62);
  font-size: 36px;
  border-radius: 20px;
}
</style>
